export class CampaignsMetricsBuilder {
    constructor() {
        this.metrics = {};
    }

    setEngagements(engagements){
        this.metrics.engagements = engagements;
        return this;
    }

    setLikes(likes) {
        this.metrics.likes = likes;
        return this;
    }

    setReplies(replies){
        this.metrics.replies = replies;
        return this;
    }

    setComments(comments) {
        this.metrics.comments = comments;
        return this;
    }


    build(){
        return this.metrics;
    }
}